export enum EnumMenuPrincipalStatus{
    Aberto = 'Aberto',
    Fechado = 'Fechado'
}
